import React from 'react';
import _ from 'lodash';

const DefaultCell = ({data, column, meet, style}) => {
  const lifter = data.lifter;
  if(data.row === 'header') {
    return (
      <div style={style} className="table-cell-inner">
        {column.label}
      </div>
    );
  } else if(data.row === 'title') {
    return (
      <div style={style} className="table-cell-inner">{data.name}</div>
    );
  } else {
    const name = _.get(lifter, column.key);
    if(name.length < 20) {
      style = {...style, fontSize: style.fontSize*1.3};
    }
    return (
      <div style={style} className="table-cell-inner ellipsis">
        { name }
      </div>
    );
  }
};

export default DefaultCell;
